import React, { useEffect, useState } from 'react';

// Styles & Assets
import styles from './QuestionsForm.module.css';

// Services
import { sortByAttribute } from '../../../services/sort';

// Components
import CircleSelector from '../CircleSelector/CircleSelector';

// Interfaces
import { PollAnswer, PollQuestion } from '../../../interfaces/Poll';

const QuestionsForm: React.FC<{
    questions: PollQuestion[],
    updateAnswer: (answer: PollAnswer | undefined) => void
}> = ({ questions, updateAnswer }) => {

    const [answersIndex, setAnswersIndex] = useState<(number | undefined)[]>(Array(questions.length).fill(undefined));
    const [textAnswers, setTextAnswers] = useState<string[]>(Array(questions.length).fill(''));

    useEffect(() => {
        setAnswersIndex(Array(questions.length).fill(undefined));
        setTextAnswers(Array(questions.length).fill(''));
    }, [questions]);

    const handleClickAnswer = (
        indexQuestion: number,
        indexAnswer: number,
        answer: PollAnswer | undefined,
        question: PollQuestion
    ) => {
        updateAnswer(
            answer
                ? {
                    ...answer,
                    inquiry_question_id: question.id
                }
                : undefined
        );

        setAnswersIndex(oldAnswersIndex => {
            const copyAnswers = [...oldAnswersIndex];
            copyAnswers[indexQuestion] = indexAnswer;
            return copyAnswers;
        });
    };

    const handleChangeTextArea = (
        indexQuestion: number,
        evt: React.FormEvent<HTMLTextAreaElement>,
        question: PollQuestion
    ) => {
        const value = (evt.target as HTMLTextAreaElement).value;

        setTextAnswers(oldTextAnswers => {
            const copyTextAnswers = [...oldTextAnswers];
            copyTextAnswers[indexQuestion] = value;
            return copyTextAnswers;
        });

        const hiddenAnswer = sortByAttribute(question.answers ?? [], 'order')[0];

        updateAnswer(
            value.trim() !== '' && hiddenAnswer
                ? {
                    ...hiddenAnswer,
                    inquiry_question_id: question.id,
                    description: value
                }
                : undefined
        );
    };

    return (
        <div className={styles.questionsContainer}>
            {sortByAttribute(questions, 'order').map((question, indexQ) =>
                <div key={question.uuid || question.id} className={styles.question}>
                    <p className={styles.questionDescription}>
                        {indexQ + 1}. {question.description} {question.required ? '*' : ''}
                    </p>

                    {question.inquiry_question_type_id === 1 ? (
                        <div className={styles.optionsContainer}>
                            {sortByAttribute(question.answers ?? [], 'order').map((answer, index) =>
                                <CircleSelector
                                    key={answer.uuid || answer.id}
                                    text={answer.description || ''}
                                    active={answersIndex[indexQ] === index}
                                    handleClick={() => handleClickAnswer(indexQ, index, answer, question)}
                                />
                            )}
                        </div>
                    ) : question.inquiry_question_type_id === 3 ? (
                        <textarea
                            className={styles.textArea}
                            value={textAnswers[indexQ]}
                            onChange={(evt) => handleChangeTextArea(indexQ, evt, question)}
                        />
                    ) : null}
                </div>
            )}
        </div>
    );
};

export default QuestionsForm;